import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/imgs/about-2.png")